<template>
  <v-main>
    <!-- :src="require(`@/assets/${src}`)" -->
    <!-- dark -->
    <!-- gradient="to top, #00000080, #00000080" -->
    <v-img :key="src" min-height="100vh" :height="$vuetify.breakpoint.mdAndUp ? '100vh' : undefined">
      <div :class="[$vuetify.breakpoint.mdAndUp && 'fill-height']" class="d-block d-md-flex">
        <page-app-bar />

        <router-view/>

        <page-footer />
      </div>
    </v-img>
  </v-main>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'

  export default {
    name: 'PageView',

    components: {
      PageAppBar: () => import('./AppBar'),
      PageFooter: () => import('./Footer'),
    },

    data: () => ({
      srcs: {
        '/pages/lock/': 'dark-green.jpg',
        '/users/-/sign-in': 'dark-green.jpg',
        '/users/-/sign-up': 'dark-green.jpg',
        '/users/-/sign-up/confirm-email': 'dark-green.jpg'
      },
    }),

    computed: {
      path: get('route/path'),
      src () {
        return this.srcs[this.path] || 'dark-green.jpg'
      },
    },
  }
</script>
